import React, { useRef } from "react";

const VehicleImageUpload = ({
  handleChange,
  handleSubmit,
  isSubmitting = false,
  vehicleImage = null,
  isCompressing = false
}) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = (e) => {
    e.preventDefault();
    // If image is being compressed, don't allow interaction
    if (isCompressing) {
      return;
    }
    // If no image has been taken yet, trigger file input to open camera
    if (!vehicleImage && fileInputRef.current) {
      fileInputRef.current.click();
    } else if (vehicleImage && handleSubmit) {
      // If image exists, submit the form
      handleSubmit(e);
    }
  };

  const isButtonDisabled = isSubmitting || isCompressing;

  return (
    <form method="post" encType="multipart/form-data">
      <input
        ref={fileInputRef}
        name="image"
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleChange}
        disabled={isSubmitting || isCompressing}
        style={{ display: "none" }}
      />
      {isCompressing && (
        <div className="mb-2 p-2 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700">
          Compressing image... Please wait.
        </div>
      )}
      <button
        className="p-2 rounded-sm hover:bg-grey"
        type="button"
        onClick={handleButtonClick}
        disabled={isButtonDisabled}
        style={{ opacity: isButtonDisabled ? 0.6 : 1, cursor: isButtonDisabled ? "not-allowed" : "pointer" }}
      >
        {isSubmitting
          ? "Processing..."
          : isCompressing
          ? "Compressing..."
          : vehicleImage
          ? "Process Photo"
          : "Take Photo"}
      </button>
    </form>
  );
};

export default VehicleImageUpload;
